import { Entry } from 'types';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from 'helpers/local-storage';
import { StepsEnum } from 'commons';
import { LocalStorageKeys } from 'commons/local-storage';

interface AttendanceProps {
  consignmentCode: string;
  products: {
    code: string;
    ean: string;
  }[];
  invoice: string;
  step: StepsEnum;
}

function get(): AttendanceProps[] {
  const storedAttendances = getLocalStorageItem(
    LocalStorageKeys.Attendances,
    []
  );

  return storedAttendances;
}

function persist(currentAttendance: AttendanceProps) {
  const attendances = get();
  const currentAttendanceExists = attendances.some(
    (attendance) =>
      currentAttendance.consignmentCode === attendance.consignmentCode
  );
  let newAttendances: AttendanceProps[] = [];

  if (currentAttendanceExists) {
    newAttendances = attendances.map((attendance) => {
      const isCurrentAttendance =
        attendance.consignmentCode === currentAttendance.consignmentCode;

      return isCurrentAttendance ? currentAttendance : attendance;
    });
  } else {
    newAttendances = attendances;
    newAttendances.push(currentAttendance);
  }

  setLocalStorageItem(LocalStorageKeys.Attendances, newAttendances);
}

function getCurrent({
  entries,
  consignmentCode,
}: {
  entries: Entry[];
  consignmentCode: string;
}): AttendanceProps {
  const attendances = get();
  const currentAttendance = attendances.find(
    (attendance) => attendance.consignmentCode === consignmentCode
  );

  const defaultProducts = entries.map((entry) => {
    return {
      code: entry.product.code,
      ean: '',
    };
  });

  return {
    consignmentCode: currentAttendance?.consignmentCode || consignmentCode,
    products: currentAttendance?.products || defaultProducts,
    invoice: currentAttendance?.invoice || '',
    step: currentAttendance?.step || StepsEnum.None,
  };
}

export const storedAttendance = {
  get,
  persist,
  getCurrent,
};
